/* eslint-disable react/display-name */
import React from "react";
import { useSelected } from "slate-react";

const InlineChromiumBugfix = () => (
  <span
    contentEditable={false}
    style={{
      fontSize: 0,
    }}
  >
    ${String.fromCodePoint(160) /* Non-breaking space */}
  </span>
);

const Link = React.forwardRef(({ attributes, element, children, style }, ref) => {
  const { url } = element;
  const selected = useSelected();

  return (
    <a
      ref={ref}
      css={{
        fontSize: 20,
        lineHeight: "34px",
        color: "#0071bb",
        textDecoration: "none",
        boxShadow: selected ? "0 0 0 3px #ddd" : undefined,
      }}
      href={url}
      {...attributes}
      style={style}
      target="_blank"
      rel="noopener noreferrer"
    >
      <InlineChromiumBugfix />
      {children}
      <InlineChromiumBugfix />
    </a>
  );
});

export default Link;
